/**
 * AME Category Dropdown — keyboard-accessible grouped category panel
 * Replaces native <select> with custom styled dropdown
 */
(function () {
  'use strict';

  var wrapper = document.querySelector('[data-ame-category-dropdown]');
  if (!wrapper) return;

  var trigger = wrapper.querySelector('.ame-category-dropdown__trigger');
  var panel = wrapper.querySelector('.ame-category-dropdown__panel');
  if (!trigger || !panel) return;

  var options = panel.querySelectorAll('[role="option"]');
  var activeIndex = -1;

  function open() {
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    activeIndex = -1;
  }

  function close(returnFocus) {
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    clearActive();
    if (returnFocus) trigger.focus();
  }

  function clearActive() {
    for (var i = 0; i < options.length; i++) {
      options[i].classList.remove('ame-category-dropdown__option--active');
    }
  }

  function setActive(index) {
    if (index < 0) index = options.length - 1;
    if (index >= options.length) index = 0;
    clearActive();
    activeIndex = index;
    options[activeIndex].classList.add('ame-category-dropdown__option--active');
    options[activeIndex].focus();
  }

  trigger.addEventListener('click', function () {
    panel.hidden ? open() : close(true);
  });

  trigger.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' || e.key === 'Down') {
      e.preventDefault();
      open();
      setActive(0);
    }
  });

  panel.addEventListener('keydown', function (e) {
    switch (e.key) {
      case 'ArrowDown':
      case 'Down':
        e.preventDefault();
        setActive(activeIndex + 1);
        break;
      case 'ArrowUp':
      case 'Up':
        e.preventDefault();
        setActive(activeIndex - 1);
        break;
      case 'Home':
        e.preventDefault();
        setActive(0);
        break;
      case 'End':
        e.preventDefault();
        setActive(options.length - 1);
        break;
      case 'Escape':
      case 'Esc':
        e.preventDefault();
        close(true);
        break;
    }
  });

  document.addEventListener('click', function (e) {
    if (!wrapper.contains(e.target)) close(false);
  });

  wrapper.addEventListener('focusout', function (e) {
    if (!wrapper.contains(e.relatedTarget)) close(false);
  });
})();
